import React from 'react'
import TestLog from '../Components/TestLog/TestLog'

const TestLogView = () => {
  return (
    <div>
        <TestLog/>
    </div>
  )
}

export default TestLogView